import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

/** Asks why a payment request is being declined; closes with the reason, or null. */
@Component({
  selector: 'app-reject-request-dialog',
  imports: [FormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule],
  templateUrl: './reject-request-dialog.html',
})
export class RejectRequestDialog {
  readonly dialogRef = inject(MatDialogRef<RejectRequestDialog, string | null>);
  readonly data = inject<{ supplierName?: string }>(MAT_DIALOG_DATA, { optional: true }) ?? {};
  readonly maxLength = 500;

  reason = '';

  get valid(): boolean {
    return this.reason.trim().length > 0;
  }
}
